"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FXPServiceCatalog;
(function (FXPServiceCatalog) {
    FXPServiceCatalog["FxpConfigurationService"] = "FxpConfigurationService";
    FXPServiceCatalog["FxpEventBroadCastService"] = "FxpEventBroadCastService";
    FXPServiceCatalog["FxpStateTransitionService"] = "FxpStateTransitionService";
    FXPServiceCatalog["FxpHttpService"] = "FxpHttpService";
    FXPServiceCatalog["AdalLoginHelperService"] = "AdalLoginHelperService";
    FXPServiceCatalog["AdminLandingService"] = "AdminLandingService";
    FXPServiceCatalog["DashboardService"] = "DashboardService";
    FXPServiceCatalog["DataService"] = "DataService";
    FXPServiceCatalog["FxpAuthorizationService"] = "FxpAuthorizationService";
    FXPServiceCatalog["FxpBreadcrumbService"] = "FxpBreadcrumbService";
    FXPServiceCatalog["FxpFeedbackService"] = "FxpFeedbackService";
    FXPServiceCatalog["FxpMessageService"] = "FxpMessageService";
    FXPServiceCatalog["FxpRouteService"] = "FxpRouteService";
    FXPServiceCatalog["FxpStorageService"] = "FxpStorageService";
    FXPServiceCatalog["FxpToastNotificationService"] = "FxpToastNotificationService";
    FXPServiceCatalog["HelpCentralService"] = "HelpCentralService";
    FXPServiceCatalog["NotificationActionCenter"] = "NotificationActionCenter";
    FXPServiceCatalog["NotificationService"] = "NotificationService";
    FXPServiceCatalog["NotificationStore"] = "NotificationStore";
    FXPServiceCatalog["OBOUserService"] = "OBOUserService";
    FXPServiceCatalog["PageLoaderService"] = "PageLoaderService";
    FXPServiceCatalog["pageTourEventService"] = "pageTourEventService";
    FXPServiceCatalog["PersonalizationService"] = "PersonalizationService";
    FXPServiceCatalog["PlannedDownTimeService"] = "PlannedDownTimeService";
    FXPServiceCatalog["SystemMessagesService"] = "SystemMessagesService";
    FXPServiceCatalog["TimeZoneHelper"] = "TimeZoneHelper";
    FXPServiceCatalog["UserInfoService"] = "UserInfoService";
    FXPServiceCatalog["UserClaimsService"] = "UserClaimsService";
    FXPServiceCatalog["UserProfileService"] = "UserProfileService";
    FXPServiceCatalog["FxpLoggerService"] = "FxpLoggerService";
    FXPServiceCatalog["ConFitService"] = "ConFitService";
    FXPServiceCatalog["FeatureFlagService"] = "FeatureFlagService";
    FXPServiceCatalog["FxpUIData"] = "FxpUIData";
    FXPServiceCatalog["deviceFactoryProvider"] = "DeviceFactory";
    FXPServiceCatalog["settingsServiceProvider"] = "SettingsService";
    FXPServiceCatalog["StateService"] = "$state";
    FXPServiceCatalog["FxpPartnerHttpInterceptorHooks"] = "FxpPartnerHttpInterceptorHooks";
    FXPServiceCatalog["FxpContext"] = "FxpContextService";
    FXPServiceCatalog["LazyLoaderService"] = "LazyLoaderService";
    FXPServiceCatalog["FxpGlobalStoreService"] = "FxpGlobalStoreService";
    FXPServiceCatalog["FxpIrisBotService"] = "FxpIrisBotService";
    FXPServiceCatalog["FxpOCVFeedbackService"] = "FxpOCVFeedbackService";
})(FXPServiceCatalog = exports.FXPServiceCatalog || (exports.FXPServiceCatalog = {}));
